import { useParams } from 'react-router-dom';
import Button from '../../../forms/inputs/button';
import Api from '../Api';
import BackButton from '../Components/BackButton';
import PrintButton from '../Components/PrintButton';
import { usePools } from '../DatabaseContext';
import React, { useEffect, useState } from 'react';
import FormContainer from '../Fields/FormContainer';
import ProductRecommender from '../Maths/ProductRecommender';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';
import ProductRecommendation from '../Components/ProductRecommendation';
import ValidationError from '../../../forms/utilities/validation-error';

export default function RecommendationPage({ i18n }) {
    const { id } = useParams()
    const { setPoolId, pool } = usePools()
    const [busy, setBusy] = useState(true)
    const [recommendations, setRecommendations] = useState([])

    useEffect(() => {
        setPoolId(id)
    }, [id])

    useEffect(async () => {
        if (pool) {
            const { products, heatLoss } = await ProductRecommender(pool);

            products.forEach(product => {
                const match = (pool.selected_products || []).find(p => {
                    return `${p.product_id}` === `${product.model.product_id}` && `${p.model}` === `${product.model.model}`
                })

                product.selected = !!match;
            })

            Api.updateConfiguration(pool.id, {
                product_recommendations: products.map(({ model }) => ({
                    model: model.model,
                    product_id: model.product_id,
                    hash: model.hash,
                })),
                heat_loss: heatLoss,
                product_analysis: products.map(({ model, analysis }) => {
                    return {
                        model: model.meta.title,
                        analysis,
                    }
                }),
            })

            setRecommendations(products)
            setBusy(false)
        }
    }, [pool])

    const enquire = () => {
        setBusy(true)

        const url = new URL(i18n.forms.enquiryUrl)

        url.searchParams.set('id', pool.id)
        url.searchParams.set('back_url', window.location.href)

        window.location = url.toString()
    }

    const onChange = () => {
        const selected = recommendations.filter(p => p.selected).map(({ model }) => ({
            model: model.model,
            product_id: model.product_id,
            hash: model.hash,
        }))

        Api.updateConfiguration(pool.id, {
            selected_products: selected,
        })
    }

    if (!pool) {
        return <BubbleLoader />
    }

    return <FormContainer breadcrumb={[
        { label: pool.name, url: `/${pool.id}/name` },
        { label: i18n.dimensions.heading, url: `/${pool.id}/dimensions` },
        { label: i18n.temperature.heading, url: `/${pool.id}/temperature` },
        { label: i18n.location.heading, url: `/${pool.id}/location` },
        { label: i18n.seasons.heading, url: `/${pool.id}/seasons` },
        { label: i18n.power.heading, url: `/${pool.id}/power` },
        { label: i18n.summary.heading, url: `/${pool.id}/summary` },
        { label: i18n.recommendations.heading },
    ]} >

        <div className="flex flex-wrap items-center justify-between">
            <div className="w-full md:w-1/2">
                <h2 className="text-xl font-bold">{ i18n.recommendations.heading }</h2>
                <p className="mt-1 text-grey-500">{ i18n.recommendations.bodyCopy }</p>
            </div>
            <div className="mt-6 md:mt-0 w-full md:w-1/2 flex md:justify-end">
                <PrintButton id={ pool.id }>
                    <span className="flex items-center text-sm underline md:hover:text-green">
                        <span>
                            <svg width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" fillRule="evenodd">
                                <path d="M3.669 0v4.346H0v10.577h3.669v3.642h12.769v-3.642h3.623V4.346h-3.623V0H3.668zm1.146 4.346h10.476v-3.2H4.815v3.2zM1.146 5.492h17.768v8.284h-2.476v-3.624H3.668v3.624H1.147V5.492zm3.67 11.926H15.29v-6.12H4.815v6.12z"/>
                                <path d="M14.785 8.595h1.617V6.978h-1.617zM6.806 13.88H13.3v-1.146H6.806zM6.806 15.982H13.3v-1.146H6.806z"/></g>
                            </svg>
                        </span>
                        <span className="pl-3">
                            { i18n.recommendations.print }
                        </span>
                    </span>
                </PrintButton>
            </div>
        </div>

        <div className="mt-12 space-y-10">
            { recommendations.length || busy ? recommendations.map((product, index) => <ProductRecommendation key={index} onChange={onChange} product={product} i18nRecommendations={i18n.recommendations} />) : <ValidationError textSize="text-base">
                { i18n.recommendations.noResults }
            </ValidationError>}
        </div>

        <div className="mt-8 md:mt-12 flex flex-wrap items-center sm:space-x-10">
            <div className="w-full sm:w-auto">
                <Button busy={ busy } onClick={ enquire }>
                    { i18n.recommendations.button }
                </Button>
            </div>
            <div className="w-full sm:w-auto">
                <BackButton className="mt-8 sm:mt-0" url="/">
                    { i18n.recommendations.back }
                </BackButton>
            </div>
        </div>

    </FormContainer>
}
